import type { CartLine } from './types'

export const cartLineKey = (
  line: Pick<CartLine, 'supplierKind' | 'supplierOrganizationId' | 'privateSupplierId' | 'catalogItemId'>,
): string => {
  if (line.supplierKind === 'external') {
    return `ext:${line.privateSupplierId ?? 0}:${line.catalogItemId}`
  }
  return `reg:${line.supplierOrganizationId ?? 0}:${line.catalogItemId}`
}
